import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Alert from "../ui/Alert";
import TextButton from "../ui/TextButton";
import { kbdEvent } from "../utils/Utils";
import Button from "../ui/Button";
import { useTabs } from "../hooks/useTabs";

export default function Options(props) {
    const {
        controller = "",
        route = "",
        menu = [],
        callback = () => { },
        title = "Confirm?",
        description = "",
        start_index = 0,
        closeable = true,
    } = props;



    const { tabs, index, help, update, setIndex, editProps, next, prev, refs, getVal } = useTabs(menu, menu[start_index]?.key);

    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();
    }, [index]);


    useEffect(() => {

        const actions = [
            {
                key: KBD.ESCAPE, action: () => {
                    if (closeable) {
                        callback(false)
                    }
                }
            },
            { key: KBD.ARROW_LEFT, action: () => prev() },
            { key: KBD.ARROW_RIGHT, action: () => next() },
            {
                key: KBD.TAB, action: (e) => {
                    e.preventDefault();
                    next()
                }
            },
            {
                key: KBD.SHIFT_TAB, action: (e) => {
                    e.preventDefault();
                    prev()
                }
            }
        ];

        const cleanup = listen(controller, route, actions, false);
        return cleanup;
    }, [index, tabs]);


    const selectOption = (_item) => {
        callback(_item?.value);
    }


    return (
        <Alert
            title={title}
            dismissible={closeable}
            callback={callback}
            description={
                <>
                    {description}
                    <div style={{ margin: "0 auto", width: "160px", textAlign: "center" }}>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        {menu.map(item => {
                            return <TextButton style={{ "margin": "0px 3px" }} {...editProps([item.value])} onEnter={() => selectOption(item)} onClick={() => selectOption(item)}>
                                {item.label}
                            </TextButton>
                        })}
                        {/* <TextButton ref={yesRef} onEnter={() => kbdEvent(KBD.Y)} onClick={() => kbdEvent(KBD.Y)}>
                            <strong>Y</strong>es
                        </TextButton>
                        &nbsp;
                        <TextButton ref={noRef} onEnter={() => kbdEvent(KBD.Y)} onClick={() => kbdEvent(KBD.N)}>
                            <strong>N</strong>o
                        </TextButton> */}
                    </div>

                </>
            }
        />
    );
}
